<template>
    <q-layout class="row items-center justify-center q-pa-none">
        <q-card class="no-shadow border-grey column flex">
            <!-- Form Header -->
            <q-card-section class="form__header">
                <div
                    class="form__title card-container"
                    :class="{
                        'safe-area-padding': isLoginPage
                    }"
                >
                    <img
                        class="logo vertical-middle"
                        src="@assets/iotorq_lean_logo.svg"
                        alt="ioTORQ LEAN Logo"
                    />
                </div>
            </q-card-section>
            <q-page-container>
                <router-view></router-view>
            </q-page-container>
            <!-- Loading animation -->
            <loader :show="isLoading" :text="loadingText" />
        </q-card>
    </q-layout>
</template>

<script>
import Loader from '@components/Loader.vue';
import { mapState } from 'pinia';
import { useSharedStore } from '@stores/shared.js';

export default {
    name: 'Auth',
    components: { Loader },
    computed: {
        ...mapState(useSharedStore, ['isLoading', 'loadingText']),
        isLoginPage() {
            // Identify if the current route is the login page
            // This is used to add padding to the top of the login page
            return this.$route.name === 'login';
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@css/auth_forms.scss';

.logo {
    height: 80px;
}

.card-container {
    max-height: 150px;
    margin: 20px auto;
}
</style>
